import { render, staticRenderFns } from "./ProductPurchaseSummary.vue?vue&type=template&id=61952d81&scoped=true&"
import script from "./ProductPurchaseSummary.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProductPurchaseSummary.vue?vue&type=style&index=0&id=61952d81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61952d81",
  null
  
)

export default component.exports